import styled from 'styled-components';

export const StatusText = styled.span`
  font-size: 1rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.support_color_05_600};
`;
